var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55363 1.45325C8.37993 1.37401 8.19123 1.33301 8.0003 1.33301C7.80938 1.33301 7.62068 1.37401 7.44697 1.45325L1.73363 4.05325C1.61533 4.10541 1.51475 4.19084 1.44414 4.29915C1.37353 4.40746 1.33594 4.53396 1.33594 4.66325C1.33594 4.79254 1.37353 4.91904 1.44414 5.02734C1.51475 5.13565 1.61533 5.22108 1.73363 5.27325L7.45363 7.87991C7.62734 7.95915 7.81604 8.00015 8.00697 8.00015C8.19789 8.00015 8.38659 7.95915 8.5603 7.87991L14.2803 5.27991C14.3986 5.22775 14.4992 5.14231 14.5698 5.03401C14.6404 4.9257 14.678 4.7992 14.678 4.66991C14.678 4.54062 14.6404 4.41412 14.5698 4.30582C14.4992 4.19751 14.3986 4.11208 14.2803 4.05991L8.55363 1.45325Z",
    stroke: "#717182",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 8C1.33269 8.12751 1.36895 8.25244 1.43749 8.35997C1.50602 8.46749 1.60396 8.55311 1.71968 8.60667L7.45301 11.2133C7.62581 11.2916 7.81332 11.3321 8.00301 11.3321C8.1927 11.3321 8.38021 11.2916 8.55301 11.2133L14.273 8.61333C14.391 8.56029 14.491 8.47406 14.5609 8.36516C14.6307 8.25625 14.6674 8.12937 14.6663 8",
    stroke: "#717182",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 11.3335C1.33269 11.461 1.36895 11.5859 1.43749 11.6935C1.50602 11.801 1.60396 11.8866 1.71968 11.9402L7.45301 14.5468C7.62581 14.6251 7.81332 14.6656 8.00301 14.6656C8.1927 14.6656 8.38021 14.6251 8.55301 14.5468L14.273 11.9468C14.391 11.8938 14.491 11.8076 14.5609 11.6987C14.6307 11.5897 14.6674 11.4629 14.6663 11.3335",
    stroke: "#717182",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount);
export default __webpack_public_path__ + "static/media/count.cc8d52b98e2135ec5131715e37411283.svg";
export { ForwardRef as ReactComponent };